import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { IService } from "interfaces";
import { Custom, Item, Modal, Progress } from "components";
import { Box, Grid } from "@mui/material";
import { Helpers } from "utils";

type Props = {
  opened: boolean;
  clinicId: number | null;
  onOpen: () => void;
  onClose: () => void;
  onClick: (service: IService) => void;
};

export const Service = (props: Props) => {
  const { t, theme, service } = useApp();

  const [services, setServices] = useState<IService[] | null>(null);

  useEffect(() => {
    servicesEffect();
  }, []);

  const servicesEffect = async () => {
    const response = await service.service.slice(0, 8);
    setServices(response);
  };

  return (
    <Custom.Card
      title={t.title.patient.service}
      action={
        <>
          <Custom.Button size="small" variant="outlined" onClick={props.onOpen}>
            {t.action.view_all}
          </Custom.Button>
          <Modal.Service
            clinicId={props.clinicId}
            opened={props.opened}
            onClose={props.onClose}
            onClick={props.onClick}
          />
        </>
      }
    >
      <Box sx={{ position: "relative" }}>
        <Grid container spacing={theme.margin.md}>
          {services ? (
            services.length > 0 ? (
              services.map((item: IService) => {
                return (
                  <Grid item xs={6} sm={3} md key={item.serviceId}>
                    <Item.Service
                      service={item}
                      onClick={() => props.onClick(item)}
                    />
                  </Grid>
                );
              })
            ) : (
              <Progress.NoRecord height={200} />
            )
          ) : (
            Helpers.generateArray(8).map((_, i: number) => {
              return (
                <Grid item xs={4} sm={3} key={i}>
                  <Progress.PlaceholderService />
                </Grid>
              );
            })
          )}
        </Grid>
      </Box>
    </Custom.Card>
  );
};
